<div class="modal-v2-backdrop" *ngIf="isVisible">
  <div class="modal-v2-dialog" >

    <!-- modal-v2 Header -->
    <div class="modal-v2-header">
      <h5 class="modal-v2-title">{{ title }}</h5>
      <button type="button" class="btn-close" (click)="cancelForm()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- modal-v2 Body -->
    <div class="modal-v2-body">
      <form [formGroup]="form">

        <!-- Door Info (Read-only) -->
        <div class="door-info-section mb-4">
          <h6 class="section-title">Door Operation Details</h6>

          <div class="form-group mb-2">
            <label class="form-label">Operation Type</label>
            <input type="text" class="form-control disabled-field" [value]="doorOperationType" readonly>
          </div>

          <div class="row mb-2">
            <div class="col-6">
              <label class="form-label">{{ doorData?.type === 'open' ? 'Open Time' : 'Close Start' }}</label>
              <input type="text" class="form-control disabled-field" [value]="startTime" readonly>
            </div>
          </div>
        </div>

        <!-- Editable Section -->
        <div class="editable-section">
          <h6 class="section-title">Additional Information</h6>

          <div class="form-group mb-3">
            <label for="supervisorName" class="form-label">Supervisor Name *</label>
            <input id="supervisorName" type="text" class="form-control"
              formControlName="supervisorName" placeholder="Enter supervisor name">
          </div>

          <div class="form-group mb-3">
            <label for="comment" class="form-label">Comment *</label>
            <textarea id="comment" class="form-control" rows="4"
              formControlName="comment" placeholder="Enter your comment"></textarea>
          </div>
        </div>

      </form>
    </div>

    <!-- modal-v2 Footer -->
    <div class="modal-v2-footer">
      <button type="button" class="btn btn-cancel" (click)="cancelForm()">Cancel</button>
      <button type="button" class="btn btn-submit" [disabled]="form.invalid" (click)="submitForm()">Submit</button>
    </div>

  </div>
</div>
